import { frontendURL } from '../../../helper/URLHelper';
import {
  ensureOpportunityPipelinesEnabled,
  ensureOpportunityKanbanAccessAllowed,
} from '../../../helper/routeHelpers';
import OpportunityDetailsView from './components/OpportunityDetailsView';
import OpportunityKanbanView from './components/OpportunityKanbanView';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/opportunities/:opportunityId?'),
    name: 'opportunities_dashboard',
    roles: ['administrator'],
    meta: {
      hideSecondarySidebar: true,
    },
    beforeEnter: ensureOpportunityPipelinesEnabled,
    component: OpportunityDetailsView,
    props: route => ({
      opportunityId: route.params.opportunityId || null,
      conversationId: route.query.conversation_id || null,
    }),
  },
  {
    path: frontendURL('accounts/:accountId/opportunities-kanban'),
    name: 'opportunities_kanban',
    roles: ['administrator'],
    meta: {
      hideSecondarySidebar: true,
    },
    beforeEnter: ensureOpportunityKanbanAccessAllowed,
    component: OpportunityKanbanView,
  },
];
